import { __spreadArray } from 'tslib';

function arrayMoveMutable(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
array, fromIndex, toIndex) {
    var startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < array.length) {
        var endIndex = toIndex < 0 ? array.length + toIndex : toIndex;
        var item = array.splice(fromIndex, 1)[0];
        array.splice(endIndex, 0, item);
    }
}
function arrayMoveImmutable(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
array, fromIndex, toIndex
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
    array = __spreadArray([], array, true);
    arrayMoveMutable(array, fromIndex, toIndex);
    return array;
}

export { arrayMoveImmutable, arrayMoveMutable };
//# sourceMappingURL=arrayMove.esm.js.map
